import {
  GET_MACHINE_INIT,
  GET_MACHINE_SUCCESS,
  CREATE_MACHINE_INIT,
  CREATE_MACHINE_SUCCESS,
  SEND_COMAND_MACHINE_INIT,
  SEND_COMAND_MACHINE_SUCCESS,
  DELETE_MACHINE_INIT,
  DELETE_MACHINE_SUCCESS,
  ERROR_MACHINE,
  CLEAR_MACHINE,
  CLEAR_MACHINE_FLAGS,
  CONGELAR_MACHINE_INIT,
  CONGELAR_MACHINE_SUCCESS
} from '../../actionTypes';

export const getMachineInit = (data: any) => ({
  type: GET_MACHINE_INIT,
  payload: data
});

export const getMachineSuccess = (data: any) => ({
  type: GET_MACHINE_SUCCESS,
  payload: data
});

export const createMachineInit = (data: any) => ({
  type: CREATE_MACHINE_INIT,
  payload: data
});

export const createMachineSuccess = (data: any) => ({
  type: CREATE_MACHINE_SUCCESS,
  payload: data
});

export const sendCommandMachineInit = (data: any) => ({
  type: SEND_COMAND_MACHINE_INIT,
  payload: data
});

export const sendCommandMachineSuccess = (data: any) => ({
  type: SEND_COMAND_MACHINE_SUCCESS,
  payload: data
});

export const deleteMachineInit = (data: any) => ({
  type: DELETE_MACHINE_INIT,
  payload: data
});

export const deleteMachineSuccess = (data: any) => ({
  type: DELETE_MACHINE_SUCCESS,
  payload: data
});

export const congelarMachineInit = (data: any) => ({
  type: CONGELAR_MACHINE_INIT,
  payload: data
});

export const congelarMachineSuccess = (data: any) => ({
  type: CONGELAR_MACHINE_SUCCESS,
  payload: data
});

export const errorMachine = (data: any) => ({
  type: ERROR_MACHINE,
  payload: data
});

export const clearMachine = () => ({
  type: CLEAR_MACHINE
});

export const clearMachineFlags = () => ({
  type: CLEAR_MACHINE_FLAGS
});
